const tableSettings = {

    responsive: {
        details: {
            type: 'column',
            target: -1,
            className: 'all',
        },
        breakpoints: [
            {name: 'extra-large', width: Infinity},
            {name: 'large', width: 1800},
            {name: 'desktop-l', width: 1600},
            {name: 'desktop', width: 1400},
            {name: 'tablet-l', width: 1200},
            {name: 'tablet-p', width: 768},
            {name: 'mobile-l', width: 480},
            {name: 'mobile-p', width: 320}
        ]
    },

    bAutoWidth: false, // disable automatic column width calculation
    searching: false, // disable search
    info: false, // disable text of total amount of rows
    dom: '<"top"i><"data-table-wrapper"rt><"bottom"flp><"clear">', // move pagination and search under the table
    oLanguage: {
        "sLengthMenu": "Show _MENU_ lines", // change entries (lines) dropdown text
    },
    language: {
        processing: `<div id="table-skeleton" class="d-flex flex-column table-skeleton">
            <div class="table-skeleton-row table-skeleton-row-header">
                <div class="table-skeleton-item"></div>
                <div class="table-skeleton-item"></div>
                <div class="table-skeleton-item"></div>
                <div class="table-skeleton-item"></div>
                <div class="table-skeleton-item"></div>
            </div>
            <div class="table-skeleton-row">
                <div class="table-skeleton-item"></div>
                <div class="table-skeleton-item"></div>
                <div class="table-skeleton-item"></div>
                <div class="table-skeleton-item"></div>
                <div class="table-skeleton-item"></div>
            </div>
            <div class="table-skeleton-row">
                <div class="table-skeleton-item"></div>
                <div class="table-skeleton-item"></div>
                <div class="table-skeleton-item"></div>
                <div class="table-skeleton-item"></div>
                <div class="table-skeleton-item"></div>
            </div>
            <div class="table-skeleton-row">
                <div class="table-skeleton-item"></div>
                <div class="table-skeleton-item"></div>
                <div class="table-skeleton-item"></div>
                <div class="table-skeleton-item"></div>
                <div class="table-skeleton-item"></div>
            </div>
            <div class="table-skeleton-row">
                <div class="table-skeleton-item"></div>
                <div class="table-skeleton-item"></div>
                <div class="table-skeleton-item"></div>
                <div class="table-skeleton-item"></div>
                <div class="table-skeleton-item"></div>
            </div>
            <div class="table-skeleton-row">
                <div class="table-skeleton-item"></div>
                <div class="table-skeleton-item"></div>
                <div class="table-skeleton-item"></div>
                <div class="table-skeleton-item"></div>
                <div class="table-skeleton-item"></div>
            </div>
        </div>`, // loading text
        // "info": "Show lines _START_ - _END_ of _TOTAL_",
        // when no data in table
        emptyTable: `<div class="no-data-found no-data-found-table">
                <h6 class="no-data-found-title">No records available</h6>
                <p>Your entries will be displayed here</p>
                </div>`,
        zeroRecords: `<div class="no-data-found">
                <h6 class="no-data-found-title">No records available</h6>
                <p>Your entries will be displayed here</p>
                </div>`,
        // remove text from paginate buttons
        paginate: {
            next: '',
            previous: ''
        }
    },
    // always show first and last column
    columnDefs: [
        {responsivePriority: 1, targets: 0},
        {responsivePriority: 2, targets: -1},
        {
            className: 'all dtr-control',
            target: -1
        }
    ]
}


// Change markup to add needed classes
function tableMarkUpHelper(e) {
    const getClosestTableWrapper = $('div.dataTables_length').closest('.dataTables_wrapper');
    const getTables = getClosestTableWrapper.find('table');


    if (getTables.length > 1) {
        for (let i = 0; i < getTables.length; i++) {
            const getTableID = getTables[i]['id'];
            // table pagination block
            $('#' + getTableID + '_length')
                .addClass(`${$(getTables[i]).hasClass('grey-table') ? 'grey-form' : 'white-form'}  loaded`);
        }
    } else {
        $('div.dataTables_length')
            .addClass(`${$('table').hasClass('grey-table') ? 'grey-form' : 'white-form'}  loaded`);
    }

    $('div.dataTables_length label').replaceWith(function () {
        return $("<div class='table-pagination'/>").append($(this).contents());
    });

    $('div.dataTables_length select')
        .addClass('form-control bb-dropdown-select hide-checkbox')
        .selectpicker({
            styleBase: 'form-control',
            showTick: false,
        })
}

function emptyTablePreloader(element) {
    if (element.find('.dataTables_empty').length !== 0) {
        element.find('.dataTables_empty').html(window.helpers.tableSkeleton(true, true))
    } else if (element.find('.no-data-found').length !== 0) {
        element.find('.no-data-found').parent().html(window.helpers.tableSkeleton(true, true))
    }
}

function tableSkeletonLoader(isLoading, domElement) {
    if (isLoading) {
        domElement.addClass('table-skeleton');
        closeTableFooterHandler();
    } else {
        domElement.removeClass('table-skeleton');
        $('.table-columns-dropdown').removeClass('form-item-loader')
    }
}

// IMPORTANT! call inside 'initComplete' and then pass 'this' as an argument
function tableRemoveLoader({_this, serverSide, tableContainerId}) {
    if (tableContainerId) {
        $(`#${tableContainerId}`).find('#table-skeleton').remove();
    }

    if (!serverSide) {
        $(_this).prev('.dataTables_processing').addClass('disabled')
    }

    if ($(_this).closest('.table-loader').length > 0) {
        $(_this).closest('.table-loader').children('#table-preloader').remove();
        $(_this).closest('.table-loader').removeClass('table-loader')
    } else {
        $(_this).removeClass('table-loader');
        $(_this).find('#table-preloader').remove()
    }
}

function tableAddLoader(_this) {
    if (!(_this.$container.hasClass("table-loader"))) {
        _this.$container.addClass('table-loader');
    }
}


// IMPORTANT! call inside 'drawCallback' and then pass 'this' as an argument
function tablePaginationCheck(table) {
    // var paginateRow = $(this).parent().prev().children('div.dataTables_paginate');

    const isEmpty = $(table).find('.dataTables_empty');
    const paginateRow = $(table).closest('.dataTables_wrapper').find('div.bottom');
    const pageCount = Math.ceil((table.fnSettings().fnRecordsDisplay()) / table.fnSettings()._iDisplayLength);
    const getTableWrapper = $(table).closest('.dataTables_wrapper')

    if (isEmpty.length) {
        getTableWrapper.addClass('empty')
        // $(table).next().addClass('disabled');
        // $('.dataTables_length').addClass('disabled')
    } else {
        getTableWrapper.removeClass('empty')
        // $('.dataTables_length').removeClass('disabled')
        // $(table).next().removeClass('disabled');
    }

    if ($(table).data('hide-pagination')) {
        paginateRow.css("display", "none")
    }
    // if (pageCount > 1) {
    //     paginateRow.css("display", "flex");
    // } else {
    //     paginateRow.css("display", "none");
    // }
}

/*
* custom jquery data table error handler since ajax error not showing any
* placeholder
* */
function ajaxErrorTablePlaceholder(table, colspan = '100%') {
    table.append($('<tr class="odd custom">')
        .append($('<td class="dataTables_empty" colspan="' + colspan + '">')
            .append($(`<div class="no-data-found">
                            <h6 class="no-data-found-title">No records available</h6>
                            <p>Your entries will be displayed here</p>
                        </div>`
            ))
        )
    );
}

function tfootDropdownHandler(btnClassName, resetClickEvent) {
    if (resetClickEvent) {
        $(btnClassName).off('click')
    }

    $(btnClassName).on('click', function () {
        const getFooter = $(this).closest('.custom-tfoot')
        const getTr = getFooter.find('tr')
        const getHiddenTd = getFooter.find('.dtr-hidden')
        const getFooterList = getFooter.find('.custom-tfoot-child');

        if (getHiddenTd.length === 0) {
            return
        }

        if (getFooter.hasClass('active')) {
            getFooter.removeClass('active');
            getTr.removeClass('odd dt-hasChild parent')
            getFooterList.remove()
            return;
        }

        getFooter.addClass('active');
        getTr.addClass('odd dt-hasChild parent')
        getFooter.append(`
                <tr class="child custom-tfoot-child">
                    <td class="child" colspan="100%">
                        <ul id="custom-footer-data" class="dtr-details"></ul>
                    </td>
                </tr>
            `)

        getHiddenTd.each(function (index, item) {
            if ($(item).data('column-name')) {
                $('#custom-footer-data').append(`
                    <li>
                        <span class="dtr-title">
                            <span class="table-header">${$(item).data('column-name')}</span>
                        </span>
                        <span class="dtr-data">
                            <div class="table-skeleton-item">${$(item).text()}</div>
                        </span>
                    </li>
                `)
            }
        })
    })
}

function closeTableFooterHandler() {
    const customFooter = '.custom-tfoot';
    $(customFooter).removeClass('active')
    $(`${customFooter} tr`).removeClass('odd dt-hasChild parent')
    $('.custom-tfoot-child').remove()
}


module.exports = {
    tablePaginationCheck,
    tableRemoveLoader,
    tableSettings,
    tableMarkUpHelper,
    tableAddLoader,
    tableSkeletonLoader,
    emptyTablePreloader,
    ajaxErrorTablePlaceholder,
    tfootDropdownHandler,
    closeTableFooterHandler
}
